import {
  ITEM_SERVICE_TYPES,
  type ItemServiceRate,
  type ItemServiceType,
} from '@/types';

/** Local form state (string) for one service type. */
export interface ServiceFormState {
  available: boolean;
  normal: string;
  urgent: string;
}

export type ServiceFormMap = Record<ItemServiceType, ServiceFormState>;

export function buildServiceForm(
  services?: Record<ItemServiceType, ItemServiceRate>,
): ServiceFormMap {
  return ITEM_SERVICE_TYPES.reduce((acc, key) => {
    const rate = services?.[key];
    acc[key] = {
      available: rate?.available ?? false,
      normal: rate?.normal != null ? String(rate.normal) : '',
      urgent: rate?.urgent != null ? String(rate.urgent) : '',
    };
    return acc;
  }, {} as ServiceFormMap);
}

export function toServiceRates(form: ServiceFormMap): Record<ItemServiceType, ItemServiceRate> {
  return ITEM_SERVICE_TYPES.reduce((acc, key) => {
    const value = form[key];
    acc[key] = value.available
      ? { available: true, normal: Number(value.normal), urgent: Number(value.urgent) }
      : { available: false, normal: null, urgent: null };
    return acc;
  }, {} as Record<ItemServiceType, ItemServiceRate>);
}

/** Financial numeric input: non-negative, up to two decimals. */
export const PRICE_RE = /^\d+(\.\d{1,2})?$/;

export function validateService(
  form: ServiceFormMap,
  t: (key: string) => string,
): Record<string, string> {
  const errors: Record<string, string> = {};
  ITEM_SERVICE_TYPES.forEach((key) => {
    const value = form[key];
    if (!value.available) return;

    if (!value.normal.trim()) errors[`${key}.normal`] = t('common.required');
    else if (!PRICE_RE.test(value.normal.trim())) errors[`${key}.normal`] = t('items.invalid.price');

    if (!value.urgent.trim()) errors[`${key}.urgent`] = t('common.required');
    else if (!PRICE_RE.test(value.urgent.trim())) errors[`${key}.urgent`] = t('items.invalid.price');
  });
  return errors;
}